import {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import LoadingSpinner from "../../components/Controls/LoadingSpinner/LoadingSpinner";
import "../../components/Pages/Code/Code.css";
import "../../../src/Shared/Css/countryFlagStyles.css";
import './RequestAccess.css';
import check from "../../assets/images/Rpost/check.png";

const RequestAccess = forwardRef(function RequestAccess({ onConfirmRequestAccess, onCancel, Email_RequestHasBeenSent, Email_PleaseWaitForApproval, Reader_OK, docSenderAddress }, ref) {
  const [openLoader, setOpenLoader] = useState(false);
  const [modelMessage, setModelMessage] = useState("");
  const [modelopen, setOpen] = useState(false);
  const [openScreen, setOpenScreen] = useState(false);
  const [openRequestSucess, setOpenRequestSucess] = useState(false);
  const [restrictedPages, setRestrictedPages] = useState([]);
  const [selectedPages, setSelectedPages] = useState([]);
  // Tracks whether the message in the sub-modal represents a success outcome.
  // When true, dismissing the sub-modal closes this popup and reopens the
  // locked-page overlay (which already hides its Request Access button via
  // `requestAccessDone` in the parent).
  const readerNotesRef = useRef();
  const lastActionSuccessRef = useRef(false);
  const [search, setSearch] = useState("");

  const documentId = useRef("");
  const readerTranslations = useRef({
    ok: "Submit",
    cancel: "Cancel",
    headerText: "Request Access",
    Reader_ID: "",
    Reader_LoadingPleaseWait: "",
    title: "Select the restricted pages you need access to.",
  });

  const filteredPages = restrictedPages.filter((p) =>
    p.toString().includes(search)
  );

  const hasSelectedPages = Object.values(selectedPages).some((pages) => pages.length > 0);
  const onSearchHandler = (e) => {
    setSearch(e.target.value.replace(/\D/g, ""));
  };

  const selectPageHandler = (page) => {
    setSelectedPages((prev) => prev.includes(page) ? prev.filter((p) => p !== page) : [...prev, page]);
  };
  const isPageDisabled = (page) => {
    const isRequested = requestedPages?.some((item) => (item.pages || []).includes(Number(page)));
    const isApproved = requestedPages?.some((item) => (item.approvedPages || []).includes(Number(page)));
    const isRejected = requestedPages?.some((item) => (item.rejectedPages || []).includes(Number(page)));
    return (isRequested || isApproved || isRejected);
  };
  const selectAllHandler = (e) => {
    if (e.target.checked) {
      const selectablePages = filteredPages?.filter((page) => !isPageDisabled(page));
      setSelectedPages(selectablePages);
    } else {
      setSelectedPages([]);
    }
  };
  const [requestedPages, setRequestedPages] = useState([]);

  useImperativeHandle(ref, () => {
    return {
      onShow(isOpen, docId, translations, pageRestrictionDetails, requestedRestrictionDetails) {
        setOpenScreen(isOpen);
        documentId.current = docId;

        if (translations) {
          readerTranslations.current = {
            ...readerTranslations.current,
            headerText: translations.headerText || readerTranslations.current.headerText,
            Reader_LoadingPleaseWait:
              translations.loadingPleaseWait || readerTranslations.current.Reader_LoadingPleaseWait,
            Reader_ID: translations.readerId || readerTranslations.current.Reader_ID,
            ok: translations.Reader_OK || readerTranslations.current.ok,
            title: translations.title || readerTranslations.current.title,
          };
        }

        // Flatten the restriction details into a unique, sorted list of page numbers.
        // pageRestrictionDetails shape: [{ pages: [1,2,3], ...}, ...]
        const flat = Array.isArray(pageRestrictionDetails)
          ? pageRestrictionDetails.flatMap((d) =>
            Array.isArray(d?.pages) ? d.pages : []
          )
          : [];
        const uniqueSorted = Array.from(new Set(flat))
          .map((p) => parseInt(p, 10))
          .filter((p) => !isNaN(p))
          .sort((a, b) => a - b);
        setRestrictedPages(uniqueSorted);
        setRequestedPages(Array.isArray(requestedRestrictionDetails) ? requestedRestrictionDetails : []);

        // All restricted pages are pre-selected. The checkboxes are rendered
        // disabled in the popup, so the user is implicitly requesting access
        // to every restricted page.
        // setSelectedPages(uniqueSorted);
      },
    };
  });
  const handleToClose = () => {
    setOpenLoader(false);
    setOpen(false);
  };
  const handleToOk = () => {
    setOpenLoader(false);
    setOpen(false);
    setOpenRequestSucess(false);
    // If the message we just showed was a success, dismissing it closes the
    // RequestAccess popup and reopens the locked-page ("You don't have
    // permission to view this page") overlay. The parent has already set
    // requestAccessDone=true, so that overlay's Request Access button is
    // not rendered.
    if (lastActionSuccessRef.current) {
      lastActionSuccessRef.current = false;
      setOpenScreen(false);
      setSelectedPages([]);
      setRestrictedPages([]);
      if (typeof onCancel === "function") {
        onCancel();
      }
    }
  };

  const onConfirmationHandler = async () => {
    // if (!selectedPages.length) {
    //   lastActionSuccessRef.current = false;
    //   setModelMessage("Please select at least one page to request access.");
    //   setOpen(true);
    //   return;
    // }
    const readerNotes = readerNotesRef?.current?.value?.trim() || "";
    setOpen(false);
    setOpenLoader(true);

    const rpdInfo = { requestedPages: selectedPages, readerNotes: readerNotes };

    try {
      // Parent (DocumentRPD) is expected to return a Promise that resolves to
      // { success: boolean }. We surface the outcome here in the sub-modal.
      const result = await Promise.resolve(onConfirmRequestAccess(rpdInfo));
      const success = !!(result && result.success);
      setOpenLoader(false);
      lastActionSuccessRef.current = success;
      setOpenRequestSucess(success);
      setOpen(true);
    } catch (err) {
      setOpenLoader(false);
      lastActionSuccessRef.current = false;
      setModelMessage("Request failed, please try again.");
      setOpen(true);
    }
  };
  const handleTextAreaValue = (e) => {
    let value = e.target.value;
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    if (value.length > 255) {
      value = value.slice(0, 255);
    }
    e.target.value = value;
  };

  const onCancelHandler = () => {
    setSearch("");
    setOpenScreen(false);
    setSelectedPages([]);
    setRestrictedPages([]);
    setOpen(false);
    lastActionSuccessRef.current = false;
    // Re-open the locked-page ("You don't have permission to view this page")
    // overlay. The parent decides whether to show its Request Access button
    // based on `requestAccessDone`.
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  return (
    <>
      {openScreen && (
        <>
          {openLoader && (
            <div className="spinerAuth-text ">
              <LoadingSpinner
                authenticatingMsg={readerTranslations.current.Reader_LoadingPleaseWait}
                class={"codeJs"}
              />
            </div>
          )}
          <div className="rpdFont modal" id="PagewModel" style={{ display: "block", backgroundColor: "#54404061" }} onContextMenu={(e) => e.preventDefault()}>
            <div className="modal-dialog modal-dialog-centered modal-customelg">
              <div className="modal-content modal-width">
                <div className="modal-header pb-1">
                  <h5 className="Rreply-text">
                    {readerTranslations.current.headerText}
                  </h5>
                  <button type="button" className="btn btn-outline-danger modalclose rpdclose" onClick={onCancelHandler}>
                    <span className="material-icons font-20">highlight_off</span>
                  </button>
                </div>
                <div className="rpdFont modal-body">
                  {restrictedPages.length > 0 ? (
                    <div className="plbm-section">
                      <div className="plbm-section-header">
                        <div className="plbm-pages-title">
                          Locked Page(s) : {restrictedPages.length}
                        </div>
                        <label className="plbm-select-all">
                          <input type="checkbox" className="plbm-checkbox"
                            checked={filteredPages.filter((p) => !isPageDisabled(p)).length > 0 && filteredPages.filter((p) => !isPageDisabled(p)).every((p) => selectedPages.includes(p))}
                            onChange={selectAllHandler}
                          />
                          <span>Select All</span>
                        </label>
                      </div>
                      <div className="plbm-search-wrapper">
                        <span className="material-icons plbm-search-icon">
                          search
                        </span>
                        <input type="text" placeholder="Search pages..." value={search} onChange={onSearchHandler} className="plbm-search-input" />
                      </div>
                      <div className="plbm-pages-grid">
                        {filteredPages.map((page) => {
                          const isDisabled = isPageDisabled(page);
                          const isSelected = selectedPages.includes(page) || isDisabled;
                          return (
                            <button key={page} type="button" disabled={isDisabled}
                              onClick={() => !isDisabled && selectPageHandler(page)}
                              className={isDisabled ? "plbm-page-btn disabled" : isSelected ? "plbm-page-btn active" : "plbm-page-btn"}>
                              {page}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <p className="text-center mt-3">
                      No restricted pages available.
                    </p>
                  )}
                  <div className="row-section mt-3">
                    <div className="left-label">
                      <span>Note:</span>
                    </div>
                    <div className="right-content">
                      <textarea ref={readerNotesRef} className="plbm-note-box" placeholder="Optional" rows="5" maxLength={255} onChange={handleTextAreaValue} />
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button type="button" className="btn btn-secondary rp-btn submit-btn" onClick={onConfirmationHandler} disabled={selectedPages.length === 0}>
                      Submit Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {modelopen === true && (
            <div
              className="modal"
              id="myModal1"
              style={{ display: "block", backgroundColor: "#8080801c" }}>
              <div className="modal-dialog modal-dialog-centered modal-customelg">
                <div className="modal-content">
                  <div className="modal-body" style={{ padding: "0.9rem" }}>
                    <h5 className={"text-center my-4 res-font14 rpdFont rd-text"}>
                      <span className="text-warn-text text-wrap-custom">
                        {modelMessage}
                      </span>
                    </h5>
                    <div className="mb-3 justify-content-center d-flex">
                      <button
                        type="button"
                        className="btn btn-secondary w-50 py-2"
                        data-bs-dismiss="modal"
                        style={{ background: "#040921" }}
                        onClick={handleToOk}>
                        {readerTranslations.current.ok}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {openRequestSucess === true && (
            <div
              className="modal"
              id="myModal1"
              style={{ display: "block", backgroundColor: "#54404061" }}
            >
              <div className="modal-dialog modal-dialog-centered modal-customelg">
                <div className="modal-content">
                  <div className="justify-content-center d-flex">
                    <div
                      className="rpdFont user_card r-login-padding"
                      id="emailsuccess"
                    >
                      <div className="d-flex justify-content-center">
                        <img src={check} alt="" className="check mb-3"></img>
                      </div>
                      <div
                        className="d-flex justify-content-center mb-3 rd-text"
                        style={{ color: "#000" }}
                      >
                        <p className="rpdFont text-center font-1rem text-nowrap1">
                          {Email_RequestHasBeenSent}
                          <span className="text-warn-text text-wrap-custom">
                            {" "}
                            {docSenderAddress}
                          </span>{" "}
                          <br></br>{" "}
                          <div className="text-wrap-custom">
                            {" "}
                            {Email_PleaseWaitForApproval}
                          </div>
                        </p>
                      </div>
                      <div className="rpdFont d-flex justify-content-center login_container">
                        <button
                          type="button"
                          className="rpdFont btn login_btn w-sm-100 w-md-50 rp-btn"
                          style={{ lineHeight: "1.6" }}
                          onClick={handleToOk}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
});

export default RequestAccess;
